import {useAsset} from "../../AssetHelper";

import './PrimaryMatch.scss'
import ScrollingText from "../components/ScrollingText";
import {Timeout} from "../displayContainer";
import {ReactNode, useContext} from "react";
import {t} from "../../i18n";
import DisplayParams from "../DisplayParams";
import {DisplayConfig} from "../Config";
import MiniTimeout, {MiniTimeoutType} from "./MiniTimeout";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {ReactSVG} from "react-svg";
import EventName from "../components/EventName";

export default function PrimaryMatch({pageTitle, pageName, smallTop, children, disableTimeout, qr, className, config} : {
    pageTitle?: ReactNode,
    pageName?: string,
    smallTop?: boolean,
    children: ReactNode,
    disableTimeout?: boolean
    qr?: string | null,
    className?: string,
    config: DisplayConfig
}) {
    const displayParams = useContext(DisplayParams);
    const sponsorSuffix = displayParams.alternatePresentingSponsor ? '_' + displayParams.alternatePresentingSponsor : '';
    const gameLogo = useAsset(`img/logos/decode_season_primary_invert${sponsorSuffix}.svg`)
    const programLogo = useAsset(displayParams.isFirstChampionship ? "img/logos/decode_fcmp_reverse.svg" : "img/logos/ftc_horiz_reverse.svg")
    const contextTimeout = useContext(Timeout)
    const timeout = disableTimeout ? {timer:{ running: false, remaining: 0 }} : contextTimeout;
    const showTimeout = !disableTimeout && timeout.timer && (config.type === 'field' || timeout.timer.remaining > 0);
    const name = <ScrollingText width={showTimeout ? "1320px" : "1500px"}><EventName /></ScrollingText>;
    return <div className={`h-100 w-100 ${className}`}>
        <div className={`primaryMatchContainer ${showTimeout ? 'timeout' : (qr ? 'qr' : '')}`}>
            <div className={`matchTopBar ${smallTop ? 'small' : ''}`}>
                <div className="pageName">{pageName}</div>
                <div className="pageTitle">{pageTitle}</div>
                {gameLogo ? <div className={"gameLogoContainer"}>
                      <img className="gameLogo" src={gameLogo} />
                </div>: null}
            </div>
            <div className={`matchBottomBar`}>
                {programLogo ? <div className={"programLogoContainer"}>
                      <img className="programLogo" src={programLogo} />
                </div> : null}
                <TransitionGroup component={null}>
                {showTimeout ?
                    <CSSTransition timeout={2000} classNames="mini-timeout">
                        <MiniTimeout type={MiniTimeoutType.EMBED} config={config} timeout={timeout}/>
                    </CSSTransition> : null}
                </TransitionGroup>
                <div className="eventName align-middle">{name}</div>
            </div>
            {children}
        </div>
    </div>;
}